import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { ThemeProvider } from './context/ThemeContext';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { TourProvider } from '@reactour/tour';
import 'moment/locale/pt';
import 'animate.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <TourProvider steps={[]} position="center">
      <App />
    </TourProvider>
  </ThemeProvider>
);
